import React from 'react'
import PropTypes from 'prop-types'
import { NavLink } from "react-router-dom"

/**
   * @class ClientCase
   * @props {object} details
   * gives all details from a client like title, thumbnail etc...
   * @props {string} classes
   * gives the CSS classes
   * Not required - col-6 by default
*/

/*  TODO
    See clientsminorcases.js (not used yet) when BO will be OK and change with the good elements.
    For example clientCase.thumbnail shoud probably be changed with
    {article._embedded['wp:featuredmedia'][0].media_details.sizes.thumbnail.source_url}
*/
class ClientCase extends React.Component {

  goTop = () => { window.scrollTo(0,0) }

  render() {
    const clientCase = this.props.details

    const classes = this.props.classes
      || (clientCase.acf["caseType"] === "0" ? "col-6 col-md-6 col-lg-4" : "col-12 col-lg-6 order-first order-md-initial")

    let block

    // Théoriquement pas possible qu'il n'y ait pas de route
    if (!clientCase.route ) {
      block = <a className="minor-cases__content">
        <h2>{clientCase.title} </h2>
        <span className="minor-cases__desc">
          <h3>{clientCase.acf["client"]}</h3>
          <p>{clientCase.tags}</p>
        </span>
      </a>
    // Cas mineur
    } else if (clientCase.route ==="/") {
      block = <a onClick={this.props.selectedClient} className="minor-cases__content">
        <span className="minor-cases__desc">
          <h3>{clientCase.acf["client"]}</h3>
          <p>{clientCase.tags}</p>
        </span>
      </a>
    // Cas majeur
    } else {
      block = <NavLink className="minor-cases__content" onClick={this.goTop} exact to={clientCase.route}>
        <h2>{clientCase.acf["baseline"]} </h2>
        <span className="minor-cases__desc">
          <h3 dangerouslySetInnerHTML={{ __html: clientCase.title }}></h3>
          <p>{clientCase.tags}</p>
        </span>
      </NavLink>
    }

    // href={ clientCase.route}
    return (
      <div className={ classes }>
        <div className="minor-cases">
          <div className="minor-cases__img__container">
            <img src= { process.env.PUBLIC_URL + "/images/" + clientCase.thumbnail.split("/").pop() } alt={"Étude de cas " + clientCase.acf["client"] } />
          </div>
          { block }
        </div>
      </div>
    )
  }
}

/**
  * Props typing
*/
ClientCase.propTypes = {
  details: PropTypes.object.isRequired,
  classes: PropTypes.string
}

/**
  * Props by default
*/
ClientCase.defaultProps = {
  classes: "col-6"
}
/*  TODO :
    define datas by default for all elements in details
*/

export default ClientCase





// WEBPACK FOOTER //
// ./src/components/ClientsCases/ClientCase.jsx